import * as React from 'react';
const defaultAccordionContext = {
    forceReindex: 0,
    accordionId: '',
    expandable: false,
    panelCount: 0,
    registerIndex: () => 0,
    isSelected: () => false,
    selectPanel: () => { },
};
export const SimpleAccordionContext = React.createContext(defaultAccordionContext);
const defaultSimpleAccordionItemContext = {
    panelId: '',
    buttonId: '',
    selected: false,
    expandable: false,
    onSelect: () => { },
};
export const SimpleAccordionItemContext = React.createContext(defaultSimpleAccordionItemContext);
//# sourceMappingURL=contexts.js.map